export const APP_VERSION = "2026.06.19";
export default APP_VERSION;
